export default __webpack_public_path__ + "static/media/carousel3.edc54922.jpg";